import { useEffect, useState } from 'react';
import cx from 'clsx';
import throttle from 'lodash-es/throttle';
import { useRouter } from 'next/router';

import { TrackClick } from '~/components/TrackEvent';
import { BRIDGE_ROUTER } from '~/constants/router';

import CTAButton from '../CTAButton';

import { MoreProductIcon } from '~/assets/icons';

const VISIBILITY_HEIGHT = 400;

interface Props {
  ctaText?: string;
  disabled: boolean;
  onClickCouponDownload?: (eventName: string) => void;
}
const EventFloatingWrapper = ({
  ctaText,
  disabled,
  onClickCouponDownload,
}: Props) => {
  const router = useRouter();
  const [visible, setVisible] = useState<boolean>(
    Boolean(document.documentElement.scrollTop),
  );

  useEffect(() => {
    const bindScrollEvent = throttle(() => {
      setVisible(VISIBILITY_HEIGHT < window.scrollY);
    }, 300);

    setVisible(VISIBILITY_HEIGHT < window.scrollY);
    window.addEventListener('scroll', bindScrollEvent);

    return () => window.removeEventListener('scroll', bindScrollEvent);
  }, []);

  const onClick = () => {
    onClickCouponDownload?.('downloaded coupon in 마켓/이벤트/CTA');
  };

  const onClickFloatingButton = () => {
    void router.push(BRIDGE_ROUTER.storeRecommend);
  };

  return (
    <div
      className={cx([
        'fixed bottom-0 right-0 left-0 flex flex-col items-end z-10 pointer-events-none transform-[translateY(0)] transition-transform duration-300',
        !visible && 'translate-y-[150px]',
        '[&>*]:pointer-events-auto [&>*]:last-child:mb-0 [&>*]:only-child:mb-20',
      ])}
    >
      <div className="mb-16 w-full px-20">
        <TrackClick
          name="clicked banner in 마켓"
          properties={{
            path: window.location.pathname,
            name: '이벤트페이지 업종 추천상품',
          }}
        >
          <button
            type="button"
            className="flex w-full items-center justify-between rounded-16 border border-solid border-success-regular bg-success-air px-16 py-12"
            onClick={onClickFloatingButton}
          >
            <p className="flex items-center typo-paragraph100-semibold">
              <MoreProductIcon className="mr-6" />
              찾는 상품이 없다면?
            </p>
            <p className="text-primary-regular typo-paragraph100-semibold">
              더 많은 상품 보러가기
            </p>
          </button>
        </TrackClick>
      </div>

      {ctaText && (
        <CTAButton text={ctaText} disabled={disabled} onClick={onClick} />
      )}
    </div>
  );
};

export default EventFloatingWrapper;
